<nav class="navbar navbar-expand navbar-dark bg-dark text-white">
  <!-- navbar-light bg-light -->

  <a class="navbar-brand" href="#">
    <img src="assets/logo.png" height="75" class="d-inline-block align-top" alt="">
    <span class="navbar-text mt-2 ml-3">{{title}}</span>
  </a>
  <div class="collapse navbar-collapse ml-5" id="navbarsExampleDefault">
    <ul class="navbar-nav mr-auto" *ngIf="isLoggedIn">
      <!-- <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="['123']">Lehrgänge</a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="['123']">Wettkämpfe</a>
      </li> -->
      <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['forms']">Formulare</a>
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/templates']">Vorlagen</a>
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/templates/texts']">Texte</a>
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/users']">Benutzer</a>
      </li>
      <!-- <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/users/teams']">Teams</a>
      </li> -->
      <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/users/roles']">Rollen</a>
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/masterdata']">Stammdaten</a>
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/settings']">Settings</a>
      </li>
    </ul>

    <ul class="navbar-nav navbar-right ml-auto" *ngIf="isLoggedIn">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/users/currentUser']">
          <fa-icon [icon]="faUser"></fa-icon>
          {{currentUser?.name}}&nbsp;&nbsp;&nbsp;</a>
      </li>
      <li class="nav-item">
        <button class="btn btn-outline-danger" (click)="logout()"><i class="fa fa-sign-out"></i> Logout</button>
      </li>
    </ul>
    <ul class="navbar-nav navbar-right ml-auto" *ngIf="!isLoggedIn">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['login']">
          <button class="btn btn-outline-success"><i class="fa fa-sign-in"></i> Login</button>
        </a>
      </li>
    </ul>
  </div>
</nav>
